export default ({ dispatch }) => next => action => {
  next(action);

  if (action.type !== 'GOOGLE_SHEETS_REQUEST') return;

  const {
    range,
    spreadsheetId,
    key,
    label
  } = action.payload;

  dispatch({type: 'LOADING', payload: {[label]: true}})
  window.gapi.load("client:auth2", function() {
        window.gapi.client
            .init({
                apiKey: key,
                clientId: "",
                scope: "",
                discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"]
            })
            .then(function() {
                var request = window.gapi.client.sheets.spreadsheets.values.get({spreadsheetId, range});
                request
                    .then(response => {
                        dispatch({
                            label,
                            type: 'GOOGLE_SHEETS_SUCCESS', 
                            payload: response.result.values.slice(1).map(row =>
                                response.result.values[0].reduce((acc, curr, i) => {
                                    acc[curr] = row[i];
                                    return acc;
                                }, {})
                            )
                        })
                        dispatch({type: 'LOADING', payload: {[label]: false}})
                    })
                    .catch(reason => {
                        dispatch({type:'GOOGLE_SHEETS_ERROR', label, payload: reason.result.error.message});
                        dispatch({type: 'LOADING', payload: {[label]: false}})
                    })
            })
            .catch(error => {
                dispatch({type:'GOOGLE_SHEETS_ERROR', label, payload: error.error.message});
                dispatch({type: 'LOADING', payload: {[label]: false}})
            })
    });
};


// WEBPACK FOOTER //
// ./src/middleware/GoogleSheets/index.js